import { ActionTypes } from '../types/action-types';
import { ActionObject } from '../types/app';

export const showDrawer = (open: boolean): ActionObject => ({
    type: ActionTypes.PROFILE_DRAWER_SHOWED,
    open
});



// WEBPACK FOOTER //
// ./src/actions/app.ts